<app-navbar></app-navbar>
<div class="container">
  <div class="notifications">
    <div class="back-button">
      <a class="d-flex g-2" (click)="goBack()">
        <img src="../../../assets/img/svg/icons/left-arrow.svg" />
        <span>{{ "notifications.back" | translate }}</span>
      </a>
    </div>

    <div class="content g-3">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h2 class="m-0">{{ "notifications.title" | translate }}</h2>
        <img src="../../../assets/img/svg/icons/notification-bell.svg" />
      </div>

      <app-notification-list
        [notificationsList]="notificationsList"
        [buttons]="true"
        [showEmptyState]="false"
        [isListViewAll]="isListViewAll"
        (toggleView)="togglerListView($event)"
      ></app-notification-list>

      <div
        *ngIf="activeState.isLoading"
        class="notification-status"
      >
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div
        *ngIf="activeState.loadError && !activeState.isLoading"
        class="notification-error"
      >
        <span class="notification-error__message">
          {{ "notifications.loadError" | translate }}
        </span>
        <button
          type="button"
          class="notification-error__retry"
          (click)="retryActivePage()"
        >
          <i class="fas fa-redo" aria-hidden="true"></i>
          <span>{{ "notifications.retry" | translate }}</span>
        </button>
      </div>

      <ng-container
        *ngIf="
          activeState.hasLoaded &&
          !activeState.isLoading &&
          !activeState.loadError &&
          activeState.notifications.length === 0
        "
      >
        <div class="list-item">
          <img src="../../../assets/img/svg/icons/notification-speaker.svg" />
          <span class="list-item__description list-item__description--none">
            {{ "notifications.none" | translate }}
          </span>
        </div>
      </ng-container>

      <div #scrollSentinel class="scroll-sentinel"></div>
    </div>
  </div>
</div>
